import { identity, isNil } from 'ramda';
import React, { useEffect, useState } from 'react';
import { Col, Label, Row } from 'reactstrap';
import Constants from '../../../Constants';
import { getHtmlElUID } from '../../../utils/helpers';
import { getErrMsgByErrKey } from '../Errors/Errors';

const { layoutGridSize, formLabelSize, formLabelSizeSm } = Constants;

const Inputs = (props) => {
  const {
    id = props.id || getHtmlElUID('lsn-form-input-'),
    type = 'text',
    title,
    name,
    value,
    disabled,
    autoComplete = false,
    errorMessages = '',
    renderCustomErrors,
    onInputChange = () => void 0,
    hidden = false,
    required = false,
    renderInput = null,
    labelTooltip = null,
    classNames = '',
    refProps,
    refInput,
    unlinkLabel = false,
    ariaLabel = '',
    placeholder = '',
    keepLabelTopAligned = true,
    renderStatusMessage,
    labelSize = (!!props.title ? props.labelSize || formLabelSize : 0),
  } = props;

  const controlSize = (layoutGridSize - labelSize) || layoutGridSize;
  const controlSizeSm = layoutGridSize - formLabelSizeSm;
  const [errMessage, setErrMessage] = useState(errorMessages);

  const handleInputChange = (value) => {
    onInputChange(props, value);
  };

  const renderDefaultInput = () => {
    return (
      <React.Fragment>
        <input
          title={title}
          aria-label={ariaLabel}
          aria-invalid={!!errMessage}
          aria-describedby={errMessage ? `${id}_error` : ''}
          ref={refInput}
          type={type || "text"}
          disabled={disabled}
          autoComplete={autoComplete || void 0}
          value={value}
          className={['input', errMessage && required ? 'border-error' : null].filter(identity).join(' ')}
          id={id}
          name={name}
          data-testid={name}
          placeholder={placeholder}
          onChange={evt => handleInputChange(evt.target.value)}
        />
        {type === 'search' ? (
          <span className="search-icon">
            <i className="fa fa-search"></i>
          </span>
        ) : void 0}
      </React.Fragment>
    );
  }

  const renderInputProxy = () => {
    return renderInput ? renderInput({
      inputFields: props,
      onInputFieldChange: handleInputChange,
      hasError: !!errMessage,
      renderDefaultInput,
    }) : renderDefaultInput();
  }

  const renderErrors = () => {
    const errId = `${id}_error`;
    const errClass = 'input-error';
    return (
      <div className={['lsn-form-item-error height-25 v-align-top'].filter(identity).join(' ')}>
        { !errMessage && !renderCustomErrors ? void 0 : (
            renderCustomErrors ? renderCustomErrors({ errMessage, errClass, errId, }) :
            (<span id={errId} role="alert" className={errClass} hidden={!errMessage}>
              {errMessage}
            </span>)
        )}
      </div>
    );
  }

  const renderStatusMessageProxy = () => {
    return renderStatusMessage ?
      <div className={['lsn-form-item-status', 'pTop-2', 'pBottom-15'].filter(identity).join(' ')}>
        <Col
          md={{ size: controlSize, offset: labelSize }}
          sm={{ size: controlSizeSm, offset: formLabelSizeSm }}>
          {renderStatusMessage()}
        </Col>
      </div> : void 0;
  };

  useEffect(() => {
    isNil(errorMessages) ? setErrMessage('') : setErrMessage(getErrMsgByErrKey(errorMessages === true ? 'empty' : errorMessages, title));
  }, [errorMessages]);

  return (
    <div ref={refProps} className={['lsn-form-item', classNames].join(' ')} hidden={!!hidden}>
      <Row className={["lsn-form-label-control relative", keepLabelTopAligned ? null : 'v-middle-align'].filter(identity).join(' ')}>
        <Label
          hidden={!title}
          for={unlinkLabel ? '' : id}
          className={['lsn-form-label ScalaSansOT', keepLabelTopAligned ? 'mTop-6' : null].filter(identity).join(' ')}
          sm={formLabelSizeSm}
          md={labelSize}>
          {required ? <span className="lsn-red pRight-3">*</span> : null}
          {title}
          {labelTooltip}
        </Label>
        <Col
          sm={controlSizeSm}
          md={controlSize}
          className={[
            'lsn-form-control', 'input-left', 'relative',
          ].filter(identity).join(' ')}>
          {renderInputProxy()}
          {renderErrors()}
          {renderStatusMessageProxy()}
        </Col>
      </Row>
      {/* <div className={['lsn-form-item-error', 'pTop-5', 'pBottom-10'].filter(identity).join(' ')}>
        <Col
          md={block ? null : { size: controlSize, offset: labelSize }}
          sm={block ? null : { size: controlSizeSm, offset: formLabelSizeSm }}
          hidden={!errMessage && !renderCustomErrors}>
          {renderCustomErrors ? renderCustomErrors({ errMessage, errClass: 'input-error' }) :
            <span id={`${id}_error`} role="alert" className="input-error" hidden={!errMessage}>
              {errMessage}
            </span>}
        </Col>
      </div> */}
    </div>
  );
};

export default Inputs;
